import SpriteSymbol from "../../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "collapse",
  "use": "collapse-usage",
  "viewBox": "0 0 16 2",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 2\" id=\"collapse\"><rect width=\"16\" height=\"2\" rx=\"1\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol